import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@lib/services/auth-service.service';

/** Bloque une route tant que le feature tag n'est pas activé dans l'environnement. */
export const featureTagGuard =
  (tag: string): CanActivateFn =>
  () =>
    inject(AuthService).hasFeatureTag(tag) || inject(Router).createUrlTree(['/dashboard']);
